import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { memoizedFetchSitePersonalization } from '@atlassian/jira-personalization-service/src/services/site/index.tsx';
import { PACKAGE_NAME, TEAM_NAME, TRAIT_NAME } from '../common/constants.tsx';

export const getTrialSprintBoardProjectId = async (cloudId: string) => {
	try {
		const siteTraits = await memoizedFetchSitePersonalization({ cloudId });
		const trialSprintBoardTrait = siteTraits.find((traits) => traits.name === TRAIT_NAME);
		if (typeof trialSprintBoardTrait?.value !== 'string') {
			return undefined;
		}
		return trialSprintBoardTrait.value;
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'fetchTrialSprintBoardProjectId',
				packageName: PACKAGE_NAME,
				teamName: TEAM_NAME,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
};
